module.exports = __webpack_public_path__ + "static/media/LazyAz_web5_preview.37903394.jpg";